import React from 'react';
import { observer } from '../../shared/observer';
import { runBusy, isBusy } from '../../shared/busy';
import { initialOrderCount, maxOrderCount, isFirstOrderUsed, FIRST_ORDER_USED_NOTE } from '../../shared/orderCount';
import { FastOrderDialog } from '../Pages/FastOrderDialog';

// CTA-кнопка главного баннера. Два режима (настройка блока в ЛК):
//  * 'cart' (по умолчанию) — до добавления «Заказать» (кладёт товар в корзину
//    в стартовом количестве, как «В корзину» в каталоге: default_order_count,
//    но не ниже min_order_count), после — ссылка «К оформлению» на /cart;
//  * 'form' — открывает всплывающую форму заявки (имя, телефон, товар с
//    количеством) и корзину не трогает вовсе. Режим для лендингов.
// Цена в баннере показывается отдельно, поэтому здесь только кнопка (в отличие
// от ToCart со счётчиком).
class HeroOrderButtonView extends React.Component {
  constructor(props) {
    super(props);
    this.state = { busy: {}, dialogOpen: false };
  }

  openDialog = () => this.setState({ dialogOpen: true });

  closeDialog = () => this.setState({ dialogOpen: false });

  add = () => {
    const { params, cart } = this.props;
    if (isBusy(this, 'add') || isFirstOrderUsed(params)) return;
    const qty = Math.min(
      Math.max(initialOrderCount(params), parseInt(params.quantity, 10) || 0),
      maxOrderCount(params),
    );
    // Группа цен блока (если задана) уходит на сервер — иначе в корзину
    // попадёт базовая цена без группы; применимость сервер проверяет сам.
    const payload = { item_id: params.itemId, quantity: qty };
    if (params.priceGroupId) payload.price_group_id = params.priceGroupId;
    // при ошибке стор откатывает оптимистичное добавление, runBusy снимает
    // busy-флаг — кнопка снова активна; reject глушим от unhandled rejection
    runBusy(this, 'add', () => cart.addProductToCart(payload))
      .catch(() => {});
  };

  inCart() {
    const { params, cart } = this.props;
    return (cart.items || []).some((i) => i.item_id === params.itemId && i.quantity > 0);
  }

  render() {
    const { params } = this.props;
    const checkoutUrl = params.cartUrl || '/cart';

    if (params.orderMode === 'form') {
      return (
        <span className="ng-hero__cta-form">
          <button
            type="button"
            className="btn btn--lg ng-hero__cta"
            onClick={this.openDialog}
          >
            {params.label || 'Заказать'}
          </button>
          <FastOrderDialog
            params={params}
            open={this.state.dialogOpen}
            onClose={this.closeDialog}
          />
        </span>
      );
    }

    if (this.inCart()) {
      return (
        <a href={checkoutUrl} className="btn btn--lg ng-hero__cta">
          {params.checkoutLabel || 'К оформлению'}
          <span className="ng-hero__cta-arrow" aria-hidden="true">→</span>
        </a>
      );
    }
    if (isFirstOrderUsed(params)) {
      return <span className="ng-field-error">{FIRST_ORDER_USED_NOTE}</span>;
    }
    const busy = isBusy(this, 'add');
    return (
      <button
        type="button"
        className={'btn btn--lg ng-hero__cta' + (busy ? ' is-busy' : '')}
        disabled={busy}
        onClick={this.add}
      >
        {params.label || 'Заказать'}
      </button>
    );
  }
}

export const HeroOrderButton = observer(HeroOrderButtonView, ['cartStore']);



// WEBPACK FOOTER //
// ./app/javascript/website_newgen/js/components/Cart/HeroOrderButton.jsx